<template>
  <button class="footer-countries" @click="handlerOpenCountriesModal">
    <img
      v-if="getCurrentDeliveryCountry?.UF_COUNTRY_ISO_CODE"
      :src="`/local/templates/globalSova/node_modules/flag-icons/flags/1x1/${getCurrentDeliveryCountry?.UF_COUNTRY_ISO_CODE?.toLowerCase()}.svg`"
      :alt="getCurrentDeliveryCountry?.UF_COUNTRY_ISO_CODE"
      class="footer-countries-flag"
    />
    {{ countryText }}

    <svg class="footer-countries-arrow">
      <use xlink:href="#svg-arrow-down" />
    </svg>
  </button>
</template>

<script lang="ts" setup>
import { computed } from 'vue';
import { useStore } from '@/store';
import DeliveryCountryModal from '@components/Header/DeliveryCountry/DeliveryCountryModal.vue';
import useModal from '@use/useModal/useModal';

const { state } = useStore();
const countriesList = computed(() => state?.results?.deliveryCountries?.items);
const messages = computed(() => state?.results?.deliveryCountries?.messages);

const modal = useModal();
const handlerOpenCountriesModal = () => {
  modal.show(DeliveryCountryModal, {}, { width: '696px' });
};

const getCurrentDeliveryCountry = computed(() =>
  countriesList?.value?.find((el) => el.isUserCountry)
);

const countryText = computed(() => {
  if (getCurrentDeliveryCountry.value?.UF_COUNTRY_ISO_CODE) {
    return getCurrentDeliveryCountry.value?.UF_NAME;
  }
  return messages.value?.title;
});
</script>

<style lang="scss" scoped>
.footer-countries {
  display: flex;
  align-items: center;
  background-color: transparent;
  border: 1px solid #fff;
  color: #fff;
  padding: 8px 16px;
  font-size: 14px;
  font-weight: 500;
  line-height: 125%;
  margin-top: 24px;
  justify-self: flex-start;
  @include point-lg {
    margin-top: 40px;
  }
}
.footer-countries-arrow {
  margin-left: 4px;
  width: 20px;
  height: 20px;
  fill: #fff;
}
.footer-countries-flag {
  width: 20px;
  height: 20px;
  margin-right: 10px;
  border-radius: 50%;
}
</style>
